export const getProjectName = () => {
  // return 'generic_v2'
  if (!window['@kodix/one']) {
    return 'generic'
  }

  return window['@kodix/one'].pageLocator.resolve('ProjectName')
}
